import {
  EVENT_SET_WAPP_ROOM_FIELDS,
  EVENT_SET_WAPP_ROOM_SEEN_STATUS,
  EventSetWappRoomFieldsPayload,
  EventSetWappRoomSeenStatusPayload,
} from '@weblite/ts-action/wapp-room'

import { wappRoomsStorage } from './storage'

import { serverSub } from '$func/subscription'
import { updateRoomLastMessageDebounced } from '$logic/room-last-message'

serverSub.subscribe(
  EVENT_SET_WAPP_ROOM_SEEN_STATUS,
  async ({ patches }: EventSetWappRoomSeenStatusPayload) => {
    patches.forEach(async ({ roomId, ...fields }) => {
      const wappRoom = await wappRoomsStorage.get(roomId)
      if (wappRoom.seen < fields.seen)
        await wappRoomsStorage.set(roomId, fields)
    })
  },
)

serverSub.subscribe(
  EVENT_SET_WAPP_ROOM_FIELDS,
  async (payload: EventSetWappRoomFieldsPayload) => {
    await wappRoomsStorage.set(payload.roomId, payload.fields)
    if (
      payload.fields &&
      ('firstVisibleIid' in payload.fields ||
        'lastVisibleIid' in payload.fields)
    )
      await updateRoomLastMessageDebounced(payload.roomId)
  },
)
